<template>
  <button
    class="cookie-bottom-content-settings-btn"
    @click="$root.$emit('cookies-modal-open')"
  >{{ t('cookies.settings') }}</button>
</template>

<script>
export default {
  name: 'CookieSettingsButton'
}
</script>
